import { Injectable } from '@angular/core';


import { UserRegistration } from '../models/user.registration.interface';
import { ConfigService } from '../utils/config.service';

import { BaseService } from "./base.service";

import { Subject, map,Observable,BehaviorSubject} from 'rxjs'


import { JwtHelperService} from '@auth0/angular-jwt';

// Add the RxJS Observable operators we need in this app.

//import { MainComponent } from '../../components/main/main.component';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders,  } from '@angular/common/http';
import { catchError } from 'rxjs';



@Injectable({
    providedIn:'root'
})

export class UserService extends BaseService {

    baseUrl: string = '';

    public clearRts = new Subject<any>();

    // Observable navItem source
    private _authNavStatusSource = new BehaviorSubject<boolean>(false);
    // Observable navItem stream
    authNavStatus$ = this._authNavStatusSource.asObservable();

    private loggedIn = false;

    constructor(private http: HttpClient, private configService: ConfigService,
        private router: Router) {
        super();
        //this.loggedIn = localStorage.getItem('auth_token');
        // ?? not sure if this the best way to broadcast the status but seems to resolve issue on page refresh where auth status is lost in
        // header component resulting in authed user nav links disappearing despite the fact user is still logged in
        this._authNavStatusSource.next(this.loggedIn);
        this.baseUrl = configService.getApiURI();
    }

    register(email: string, password: string, firstName: string, lastName: string, location: string): Observable<boolean> {
        let body = JSON.stringify({ email, password, firstName, lastName, location });
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = {headers}

        return this.http.post(this.baseUrl + "/account", body, options)
            .pipe(map((res:any) => true))
            .pipe(catchError(this.handleError));
    }

    login(userName: string, password: string) {
        

        return this.http.get(this.baseUrl + '/auth/?username='+userName +'&password=' + password)
            .pipe(map((res:any) => {
                console.log(res,"---")
                localStorage.setItem('token', res.access_token);
                this.loggedIn = true;
                this._authNavStatusSource.next(true);
                return true;
            }))
            .pipe(catchError(this.handleError));
    }

    //login(userName: string, password: string) {
    //    const formData = new FormData();

    //    formData.append('grant_type', 'password'); 
    //    formData.append('client_secret', 'nt_secret_kerestir'); 
    //    formData.append('client_id', 'nt_client'); 
    //    formData.append('username', userName); 
    //    formData.append('password', password); 
    //    formData.append('scope', 'api offline_access openid profile email');
       

    //    return this.http.post(
    //        'http://192.168.254.15/api.nesiyatova/connect/token',
    //        formData
    //        )
    //        .map(res => res.json())
    //        .map(res => {
    //            localStorage.setItem('token', res.access_token);
    //            this.loggedIn = true;
    //            this._authNavStatusSource.next(true);
    //            return true;
    //        })
    //        .catch(this.handleError);
    //}

    //login(userName: string, password: string) {
    //    let headers = new Headers();
    //    headers.append('Content-Type', 'application/json');

    //    return this.http
    //        .post(
    //            this.baseUrl + '/auth/login',
    //            JSON.stringify({ userName, password }), { headers }
    //        )
    //        .map(res => res.json())
    //        .map(res => {
    //            localStorage.setItem('token', res.auth_token);
    //            this.loggedIn = true;
    //            this._authNavStatusSource.next(true);                
    //            return true;
    //        })
    //        .catch(this.handleError);
    //}

    logout(returnUrl: string) {
        localStorage.removeItem('token');
        this.loggedIn = false;
        this._authNavStatusSource.next(false);
        this.clearRts.next(void 0);

        let isMobile = /iPad|iPhone|iPod|Android/i.test(window.navigator.userAgent)

        if (returnUrl == '/' || isMobile) {
            this.router.navigate(['/']);
        }
        else {
            this.router.navigate(['/ads']);
        }        
    }

    isLoggedIn() {
        let jwtHelper = new JwtHelperService();
        let token = localStorage.getItem('token')

        // console.log(this.currentUser);
        // console.log(this.currentUser.id);

        if (!token)
            return false;

        let isExpired = jwtHelper.isTokenExpired(token);
        return !isExpired;
    }

    get currentUser() {
        let token = localStorage.getItem('token')

        if (!token)
            return false;
        return new JwtHelperService().decodeToken(token);
    }

    chackRole(rl: string) {
        let token = localStorage.getItem('token')

        if (!token)
            return false;

        let role = new JwtHelperService().decodeToken(token).role;

        let hj: string[];
        
        if (Array.isArray(role)) {
            if (role.some(r => r == rl)) return true;
        }
        else {
            if (role == rl) return true
        }

        return false
    }



    facebookLogin(accessToken: string) {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        let body = JSON.stringify({ accessToken });
        return this.http
            .post(
                this.baseUrl + '/externalauth/facebook', body, { headers })
            .pipe(map((res:any) => res.json()))
            .pipe(map((res:any) => {
                localStorage.setItem('token', res.auth_token);
                this.loggedIn = true;
                this._authNavStatusSource.next(true);
                return true;
            }))
            .pipe(catchError(this.handleError));
    }



}

